let etapas = [
    {
        id: 'produccion',
        num: 1,
        key: 'paymentDate',
        verb: 'se ha recibido por almacen',
        title: 'Está esperando a ser armado',
    },
    {
        id: 'armado',
        num: 2,
        key: 'prekitDate',
        verb: 'está armado',
        title: 'Está esperando a ser empacado',
    },
    {
        id: 'empacado',
        num: 3,
        key: 'finishDate',
        verb: 'ya está empacado',
        title: 'Está esperando a ser recolectado por la paquetería',
    },
    {
        id: 'recoleccion',
        num: 4,
        key: 'departureDate',
        verb: 'ya fue recolectado',
        title: 'Está en ruta de entrega',
    },
    {
        id: 'llegada',
        num: 5,
        key: 'arrivalDate',
        verb: 'ya fue entregado',
        title: '¡Disfruta!',
    },
]

const RastreoOptions = {
    store,
    name: 'RastreoApp',
    delimiters: ['${', '}'],
    compilerOptions:{
        isCustomElement: tag => ['quantity-input', 'cart-remove-button'].includes(tag)
    },
    data() {
        
        let response = {
            "success": true,
            "result": [
                {
                    "_id": "#CV0000",
                    "objPrioridad": {
                        "calMolestia": 0,
                        "calEnvio": 0,
                        "calExpress": 0,
                        "calPais": 0,
                        "calFecha": 0.016,
                        "calnOrdenes": 0.4,
                        "calPeso": 0.5,
                        "calTags": 0
                    },
                    "shippingAddress": {
                        "address1": "-",
                        "address2": "--",
                        "city": "--",
                        "countryName": "-",
                        "countryCode": "-",
                        "latitude": null,
                        "longitude": null,
                        "phone": "--",
                        "provinceName": "---",
                        "provinceCode": "---",
                        "zipCode": "---",
                        "lastName": "---",
                        "firstName": "---",
                        "company": "---"
                    },
                    "ordersCount": 4,
                    "gateways": [
                        "---"
                    ],
                    "molestia": 0,
                    "nota": "",
                    "customerNote": null,
                    "originPlatform": "---",
                    "prioridad": 0.916,
                    "totalDiscounts": 366,
                    "tip": 0,
                    "tags": [
                        "---"
                    ],
                    "refunds": [],
                    "trackingIDs": [
                        "----"
                    ],
                    "fulfillmentDate": "2021-12-10T19:12:01.000Z",
                    "id": "#CV0000",
                    "orderID": "000",
                    "customerID": "000",
                    "customerName": {
                        "firstName": "---",
                        "lastName": "---"
                    },
                    "phone": "",
                    "code": "",
                    "noticiasWA": true,
                    "checkoutID": 23453084254293,
                    "customerEmail": "---@---.com",
                    "lineItems": [
                        {
                            "_id": "---",
                            "sku": "MR-ECB",
                            "qty": 1,
                            "price": 45,
                            "lineItems": []
                        }
                    ],
                    "cancelDate": null,
                    "paymentDate": "2021-12-10T02:49:12.000Z",
                    "createDate": "2021-12-10T02:49:13.000Z",
                    "updateDate": "2021-12-10T19:12:08.251Z",
                    "totalPrice": 1509,
                    "totalPriceGiftCard": 0,
                    "totalWeight": 6110,
                    "volumetricWeightOrder": 6585,
                    "locationID": null,
                    "shippingMethod": "FedEx Express Saver",
                    "arrivalDate": null,
                    "addInfo": [],
                    "orderStatusURL": "---",
                    "credito": 0,
                    "transactions": [
                    ],
                    "fee": {
                        "gateway": "oxxo",
                        "amount": 68.26716,
                        "paymentMethodID": "",
                        "paymentTypeID": ""
                    },
                    "noteAttributes": [],
                    "comments": [],
                    "arrPartialPrekit": [],
                    "joinedOrders": [],
                    "createdAt": "2021-12-10T18:48:29.407Z",
                    "updatedAt": "2021-12-13T18:56:38.499Z",
                    "__v": 0,
                    "prekitStartDate": "2021-12-10T19:00:04.592Z",
                    "prekitStartInfo": {
                        "operatorID": "Hit3mopehTcwOtOOGC7kngKITOx1",
                        "operatorName": "Jacqueline Martínez"
                    },
                    "prekitDate": "2021-12-10T19:04:37.641Z",
                    "prekitInfo": {
                        "operatorID": "Hit3mopehTcwOtOOGC7kngKITOx1",
                        "operatorName": "Jacqueline Martínez"
                    },
                    "embalajeStartDate": "2021-12-10T19:05:21.029Z",
                    "departureMsgDate": "2021-12-10T19:12:00.406Z",
                    "finishDate": "2021-12-10T19:12:05.111Z",
                    "packingInfo": {
                        "operatorID": "DZeWnrpmZ9USACTNyaPhXJJjleH3",
                        "cajas": [
                            {
                                "sku": "CG-C11",
                                "weight": 8.88,
                                "largo": 40,
                                "ancho": 32,
                                "alto": 31,
                                "price": 145.42,
                                "trackingId": 287382063570,
                                "master": true,
                                "guia": 287382063570
                            }
                        ],
                        "operatorName": "E Nora Miriam Hernández",
                        "priceFedex": 145.42,
                        "priceEstafeta": 127.6,
                        "priceAMPM": 0,
                        "priceDHL": 0,
                        "mesa": 4
                    },
                    "shipment": "FedEx",
                    "shipmentPrice": 145.42,
                    "departureDate": "2021-12-10T20:09:00.000Z",
                    "estimatedDelivery": "2021-12-15T03:00:00.000Z",
                    "receiverName": null,
                    "trackingHistory": [
                        {
                            "timestamp": "2021-12-13T16:42:00.000Z",
                            "type": "IT",
                            "title": "FEDEX_FACILITY",
                            "description": "En tránsito"
                        }
                    ]
                }
            ]
        }
        
        let pedidos = response.result.map(pedidoData=> {
            
            let etapa = pedidoData.arrivalDate ? 'llegada':
            pedidoData.departureDate ? 'recoleccion':
            pedidoData.finishDate ? 'empacado' :
            pedidoData.prekitDate ? 'armado' :
            'produccion' 

            let currentEtapa = etapas.find(x=>x.id == 'etapa')

            return  {
                ...pedidoData,
                etapa,
            }

        })

        let email = ''
        let orderNumber
        
        let showDetails = false

        return {
            email,
            orderNumber,
            showDetails,
            pedidos
        }
  
    },
    computed: {
        estimatedDeliveryDate(){

            let date =  new Date(this.pedidos[0].estimatedDelivery)
            return this.pedidos[0].estimatedDelivery ? new Date( new Date(date).valueOf() - 1000*60*60*6 ).toLocaleString('es', { day: 'numeric', month: 'long', year: 'numeric', weekday: 'long' }) : ''

        },
        pedido(){

            return this.pedidos[0]
        }
    },
    created() {

        this.getRastreo()

    },
    methods:{
        regresar(){
            
            this.showDetails = false

        },
        fechaBonita(date){
            return date  ?new Date( new Date(date).valueOf()
            ).toLocaleString('es', { day: 'numeric', month: 'short', year: 'numeric', weekday: 'short', minute: '2-digit', hour: '2-digit', hour12: true })
            : ''

        },
        submitRastreo($event){

            $event.preventDefault()


            const url = new URL(window.location);

            url.searchParams.set('email', this.email);
            url.searchParams.set('orderNumber', this.orderNumber);

            window.history.pushState({}, '', url);
            this.loading=true
            this.getRastreo()
            // window.history.pushState('/pages/rastrea-tu-pedido','Prueba', '/pages/rastrea-tu-pedido?query=test')

        },
        getRastreo(){
            
            const submitButton = document.querySelector(`#btnRastrearPedido`)
            const overlay = document.querySelector(`#btnRastrearPedido .loading-overlay__spinner`)
            
            let searchParams = new URLSearchParams(window.location.search)

            this.email = searchParams.get('email')
            this.orderNumber = searchParams.get('orderNumber')
 
            
            const correo = searchParams.get('correo')
            const id = searchParams.get('id')?.replace('CV','')


            if (this.email && this.orderNumber) {
                this.loading = true
                const url = `https://shopify-qswqkvpqma-uc.a.run.app/getRastreo/${this.email}/WU${this.orderNumber.replace('WU','')}`
                // const url = `http://localhost:5000/wu-argus/us-central1/shopify/getRastreo/${this.email}/${this.orderNumber}`
                return axios.get(url).then((response) => {
                    if(response.data.error){
                        Swal.fire('Error', 'La información ingresada no es correcta','error')
                    }else{

                        this.showDetails = true
                        this.pedidos = response.data.result.map(pedidoData=> {
                
                            let etapa = pedidoData.arrivalDate ? 'llegada':
                            pedidoData.departureDate ? 'recoleccion':
                            pedidoData.finishDate ? 'empacado' :
                            pedidoData.prekitDate ? 'armado' :
                            'produccion' 
                            let currentEtapa = etapas.find(x=>x.id == etapa)
    
                            return  {
                                ...pedidoData,
                                etapa: currentEtapa,
                            }
                
                        })
                    }

                })
            } else if(correo && id) {
                this.loading = true

                const url = `https://shopify-qswqkvpqma-uc.a.run.app/getRastreo/${correo}/WU${id.replace('WU','')}`
                // const url = `http://localhost:5000/wu-argus/us-central1/shopify/getRastreo/${this.email}/${this.orderNumber}`
                return axios.get(url).then((response) => {
                    if(response.data.error){
                        Swal.fire('Error', 'La información ingresada no es correcta','error')
                    }else{

                        this.showDetails = true
                        this.pedidos = response.data.result.map(pedidoData=> {
                
                            let etapa = pedidoData.arrivalDate ? 'llegada':
                            pedidoData.departureDate ? 'recoleccion':
                            pedidoData.finishDate ? 'empacado' :
                            pedidoData.prekitDate ? 'armado' :
                            'produccion' 
                            let currentEtapa = etapas.find(x=>x.id == etapa)
    
                            return  {
                                ...pedidoData,
                                etapa: currentEtapa,
                            }
                
                        })
                    }

                })

            }

        }

    }

}

const RastreoApp = Vue.createApp(RastreoOptions)

mountVueComponent(RastreoApp, 'custom-price')

RastreoApp.mount('#rastreoApp')
RastreoApp.use(store)


